import { Injectable } from '@angular/core';

import moment from 'moment';
import { PermissionFilter } from 'src/AngularJS/Goals/Gamification/Models/permission-filter';
import { CompanySettingsService } from 'src/app/reusables/services/company-settings.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { PointStorePermissionService } from './point-store-permission.service';
import { ShoppingCartService } from '../../agent-side/services/shopping-cart.service';


@Injectable({
  providedIn: 'root'
})
export class PointStoreProductCardBaseService {

  _localizationStrings = new Map();

  constructor(
    private cvLocalizationService: CVLocalizationService,
    private companySettingsService: CompanySettingsService,
    private shoppingCartService: ShoppingCartService,
    private pointStorePermissionService: PointStorePermissionService,
  ) {
    this.loadLocalizations();
  }

  loadLocalizations() {
    this.cvLocalizationService.GetSection("MarketPlace_Management").then((map) => {
      this._localizationStrings = map;
    });
  }

  getLocalizationString(key, defaultValue) {
    if (this._localizationStrings && this._localizationStrings.has(key))
      return this._localizationStrings.get(key);
    return defaultValue;
  }

  getImagesCount(product) {
    let count = 0;
    if (product.MultipleImagesData != null && product.MultipleImagesData.length > 1) {
      let mainImages = product.MultipleImagesData.filter((i) => { return i.PointStoreProductVariationID == null || i.PointStoreProductVariationID == 0; });
      count = mainImages != null ? mainImages.length : 0;

      if (product.VariationsData != null && product.VariationsData.length > 0) {
        let variationImages = product.VariationsData.map((v) => {
          if (v.Active == null || v.Active)
            return v.PointStoreProductVariationID;
        });
        product.MultipleImagesData.forEach((currentValue, index, array) => {
          if (variationImages.includes(currentValue.PointStoreProductVariationID))
            count++;
        });
      }
      return count - 1;
    } else {
      return 1
    }
  }

  //shared
  isActive(product, type) {
    let toReturn = "";
    switch (type) {
      case "carousel":
        if (product.CarouselEnd != null && moment().isAfter(product.CarouselEnd, 'day'))
          toReturn = "inactive";
        break;
      case "featured":
        if (product.FeatureEnd != null && moment().isAfter(product.FeatureEnd, 'day'))
          toReturn = "inactive";
        break;
      case "sale":
        if (product.SaleEnd != null && moment().isAfter(product.SaleEnd, 'day'))
          toReturn = "inactive";
        break;
    }
    return toReturn;
  };


  //shared
  getProductTotalQuantity(product) {
    if (!product.HasProductVariations) {
      return product.Quantity == null ? this.getLocalizationString("Unlimited", "Unlimited") : (product.Quantity);
    } else {
      let unlimitedVariationCount = 0;
      product.VariationsData.forEach((variation, index) => {
        if (variation.VariationQuantity == null)
          unlimitedVariationCount++;
      });
      if (unlimitedVariationCount == product.VariationsData.length)
        return this.getLocalizationString("Unlimited", "Unlimited");
      else
        return this.getLocalizationString("Various", "Various");
    }
  }

  GetAssignmentTooltip(product) {
    let title = "";
    let attrNames = [];
    let groupAssignmentsTitle = "";

    if (product.PointStoreProductAllAssignments.empAssignAll) {
        groupAssignmentsTitle += this.getLocalizationString(
            "All_Groups_Assigned",
            "All Groups Assigned"
        );
    } else if (
        product.PointStoreProductAllAssignments &&
        product.PointStoreProductAllAssignments.emp.length > 0
    ) {
        let print = 4;
        let groupAssignmentLength =
            product.PointStoreProductAllAssignments.emp.length;
        let plusNumber =
            groupAssignmentLength > print
                ? groupAssignmentLength - print
                : 0;

        let forVariable = plusNumber > 0 ? print : groupAssignmentLength;

        for (let i = 0; i < forVariable; i++) {
            groupAssignmentsTitle +=
                product.PointStoreProductAllAssignments.emp[i].GroupName +
                "\n";
        }

        if (plusNumber > 0)
            groupAssignmentsTitle +=
                "\n" +
                `+${plusNumber } ${this.getLocalizationString("More", "more")}`+
                "\n";
    } else {
        groupAssignmentsTitle =
            this.getLocalizationString(
                "Product_Not_Available",
                "This product is not available. Please assign a group."
            ) + "\n";
    }

    if (
        product &&
        product.PointStoreProductAllAssignments.attr.length > 0
    ) {
        title =
            "\n" +
            this.getLocalizationString(
                "One_Attribute",
                "Need at least 1 attribute:"
            ) +
            "\n";

        let groupedAttributes =
            product.PointStoreProductAllAssignments.attr.reduce(
                (groupedObject, attribute) => {
                    if (!groupedObject[attribute.AgentAttributeID]) {
                        groupedObject[attribute.AgentAttributeID] = [];
                    }
                    groupedObject[attribute.AgentAttributeID].push(
                        attribute
                    );

                    return groupedObject;
                },
                {}
            );

        let print = 3;
        let attrAssignmentLength = Object.keys(groupedAttributes).length;
        let plusNumber =
            attrAssignmentLength > print ? attrAssignmentLength - print : 0;
        let groupedAttributesFiltered = Object.keys(
            groupedAttributes
        ).slice(0, 3);

        groupedAttributesFiltered.forEach((key) => {
            let attributeCategory =
                this.shoppingCartService.shoppingCartObj.currentUserAllAttributes.find(
                    (attr) => {
                        return (
                            parseInt(attr.AgentAttributeID) == parseInt(key)
                        );
                    }
                );
            title +=
                (attributeCategory && attributeCategory.AttributeName
                    ? attributeCategory.AttributeName
                    : "-- ") + ": ";
            groupedAttributes[key].filter((attr) => {
                attrNames.push(attr.AttributeValueName);
            });
            title += attrNames.join(", ");
            title += "\n";
            attrNames = [];
        });

        if (plusNumber > 0)
            title += "\n" +`+${plusNumber } ${this.getLocalizationString("More", "more")}`  + "\n";
    }
    return groupAssignmentsTitle + title;
}

  calculateInitialVariationPrice(product) {
    if (!product.VariationsData || product.VariationsData.length === 0 ) {
      return 0;
    }
    let initialVariationPrice = 0;
    let initialVariation = product.VariationsData.reduce((prev, curr) => {
      let prevValue = prev.VariationPrice;
      let currValue = curr.VariationPrice;
      if (prev.VariationOnSale)
        prevValue = prev.VariationPrice - (prev.VariationPrice * (product.Sale / 100));
      if (curr.VariationOnSale)
        currValue = curr.VariationPrice - (curr.VariationPrice * (product.Sale / 100));
      return prevValue < currValue ? prev : curr;
    });

    if (initialVariation.VariationOnSale)
      initialVariationPrice = Math.ceil(initialVariation.VariationPrice - ((product.Sale / 100.0) * initialVariation.VariationPrice))
    else
      initialVariationPrice = initialVariation.VariationPrice;

    return initialVariationPrice;
  }

  calculateLastVariationPrice(product) {
    if (!product.VariationsData || product.VariationsData.length === 0 ) {
      return 0;
    }
    let lastVariationPrice = 0;
    let lastVariation = product.VariationsData.reduce((prev, curr) => {
      let prevValue = prev.VariationPrice;
      let currValue = curr.VariationPrice;
      if (prev.VariationOnSale)
        prevValue = prev.VariationPrice - (prev.VariationPrice * (product.Sale / 100));
      if (curr.VariationOnSale)
        currValue = curr.VariationPrice - (curr.VariationPrice * (product.Sale / 100));
      return prevValue > currValue ? prev : curr;
    });
    if (lastVariation.VariationOnSale)
      lastVariationPrice = Math.ceil(lastVariation.VariationPrice - ((product.Sale / 100.0) * lastVariation.VariationPrice))
    else
      lastVariationPrice = lastVariation.VariationPrice;
    return lastVariationPrice;
  }

  showSale(product) {
    if (product.Sale <= 0 || product.SaleStart == null)
      return false;

    if (product.SaleEnd != null && moment().isAfter(product.SaleEnd, 'day'))
      return false;
    if (product.SaleStart != null && moment(product.SaleStart).isAfter(moment(), 'day'))
      return false;

    return true;
  }

    /**
   * filter permission list to validate ui control
   * @param permission 
   * @returns 
   */
    checkPermission(permission: string): boolean {
      return this.pointStorePermissionService.checkPermission(permission);
    }
  
    /**
     * check if user has permission to execute some operation
     * @param permissionName 
     * @returns 
     */
    async checkSinglePermission(permissionName: string) {
      let check: boolean = false;
      const filter:PermissionFilter = {
        type: 'single',
        name: permissionName
      }
      const permission = await this.pointStorePermissionService.getPermission(filter);
      if (permission) {
        check = true;
      }
      return check;
    }

    isMainImageEmptyWithMultiplesImages(product): boolean {
      return product.HasMultipleImages && (product.ProductImageID == 0 || product.ProductImageID == null) && product.MultipleImagesData && product.MultipleImagesData.length > 0;
    }
}
